export const Types = {
    SAVE_LIST_GROUP: 'SAVE_LIST_GROUP',
  }
  